/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import Button from '@taglivros/oef_componentes/build/components/button'
import styled from 'styled-components'
import { BANDEIRAS_IMAGES } from '../../../constants'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'

const ModalWrapper = styled.div`
  .card--modal {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 80px;
    justify-content: space-around;
  }
  .select-cards-modal {
    width: 100%;
    display: block;
    flex-direction: column;
    overflow: auto;
    padding: 10px 0 20px 0;
    padding-right: 15px;
  }
  .radioLabel {
    > div {
      border-color: ${( { tema } ) => tema} !important;
      &::after {
        background: ${( { tema } ) => tema} !important;
      }
    }
  }
`

const Cartao = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(19, 26, 45, 0.2);
  border-radius: 10px;
  padding: 10px;
  color: #343a4f;
  font-size: 14px;
  font-weight: 600px;
  margin-top: 10px;
  display: flex;
  ${( { isSelected, color } ) => isSelected && `border: 2px solid ${color};`}
  .bandeira {
    background-image: url(${( { bandeira } ) => bandeira && bandeira});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: 20px;
  }
  .top {
    display: flex;
    width: 100%;
    gap: 5px;
  }
  .bottom {
    padding-left: 26px;
    padding-top: 10px;
  }
  .numero {
    margin-right: 12px;
    letter-spacing: 1px;
  }
  .left {
    flex: 1;
  }
  .right {
    display: flex;
    align-items: center;
  }
`

const SelecionaCartaoExistenteModal = ( {
  active,
  closeModal,
  cartoesCadastrados,
  setSelecionaCartaoExistente,
  selecionaCartaoExistente
} ) => {
  const [ selectedCartao, setSelectedCartao ] = useState( selecionaCartaoExistente )
  const { temaFluxo } = useFluxosPagamento()
  return (
    <ModalWrapper tema={ temaFluxo }>
      <Modal
        altura="auto"
        largura="560px"
        onShowModal={ closeModal }
        show={ active }
      >
        <div className="select-cards-modal">
          {cartoesCadastrados.map( cartao => (
            <Cartao
              bandeira={ BANDEIRAS_IMAGES[ cartao.bandeira ] }
              color={ temaFluxo === '#ffa435' ? '#ffa435' : '#009BBF' }
              isSelected={ selectedCartao === cartao.id }
              key={ cartao.id }
              onClick={ () => setSelectedCartao( cartao.id ) }
            >
              <div className="left">
                <div className="top">
                  <div className="bandeira" />

                  <span>Cartão de crédito</span>
                </div>

                <div className="bottom">
                  <span className="numero">••••</span>

                  <span className="numero">{cartao.ultimosDigitos}</span>
                </div>
              </div>

              <div className="right">
                <RadioGroup defaultOption={ selectedCartao }>
                  <RadioButton value={ cartao.id } />
                </RadioGroup>
              </div>
            </Cartao>
          ) )}
        </div>

        <div className="buttons">
          <Button
            invertido
            onClick={ closeModal }
            tema={
              temaFluxo === '#ffa435'
                ? Button.BOTAO_INEDITOS
                : Button.BOTAO_CURADORIA
            }
          >
            Fechar
          </Button>

          <Button
            disabled={ !selectedCartao }
            onClick={ () => setSelecionaCartaoExistente( selectedCartao ) }
            tema={
              temaFluxo === '#ffa435'
                ? Button.BOTAO_INEDITOS
                : Button.BOTAO_CURADORIA
            }
          >
            Salvar
          </Button>
        </div>
      </Modal>
    </ModalWrapper>
  )
}
export default SelecionaCartaoExistenteModal
